import { all, call, cancel, fork, put, take, takeEvery } from 'redux-saga/effects';
import {
  deleteEntity,
  fetchResource,
  loadEntities,
  updateEntity,
  showErrorMessage,
  getIntlMessage,
  LOGOUT_ACTION_TYPES,
} from 'helpers/utilHelpers';
import {
  DELETE_TIMER,
  INIT_TIMER,
  LOAD_TIMELOGS,
  START_TIMER,
  STOP_TIMER,
  UPDATE_TIME,
  LOAD_TASK_TIMELOGS,
  DELETE_TIMER_GROUP,
  SUBSCRIBE_TIMER_STARTED,
  UNSUBSCRIBE_TIMER_STARTED,
  SUBSCRIBE_TIMER_STOPPED,
  UNSUBSCRIBE_TIMER_STOPPED,
} from 'constants/ActionTypes';
import SocketService from 'services/SocketService';
import { SOCKET } from 'constants/SocketConstants';
import { setTimerStartedSocket, setTimerStoppedSocket } from 'actions/ui/timerActions';

const socketInstance = SocketService.Instance;

function* timerFetch(action) {
  const { resource, taskId, onSuccess, onAfterSuccess } = action.payload;
  try {
    const response = yield call(() => fetchResource(resource, 'POST', { taskId }));

    if (onSuccess) {
      yield put(onSuccess(response));
    }

    if (onAfterSuccess) {
      yield put(onAfterSuccess(response));
    }
  } catch (response) {
    //TODO:
  }
}

function* deleteTimerGroupFetch(action) {
  const { resource, timerIds, onSuccess } = action.payload;
  try {
    const response = yield call(() => fetchResource(resource, 'POST', { timerIds }));

    if (onSuccess) {
      yield put(onSuccess(response));
    }
  } catch (response) {
    yield showErrorMessage(getIntlMessage('request.error'));
  }
}

function* startTimer() {
  yield takeEvery(START_TIMER, timerFetch);
}

function* stopTimer() {
  yield takeEvery(STOP_TIMER, timerFetch);
}

function* initTimer() {
  yield takeEvery(INIT_TIMER, loadEntities);
}

function* deleteTimer() {
  yield takeEvery(DELETE_TIMER, deleteEntity);
}

function* updateTime() {
  yield takeEvery(UPDATE_TIME, updateEntity);
}

function* deleteTimerGroup() {
  yield takeEvery(DELETE_TIMER_GROUP, deleteTimerGroupFetch);
}

function* loadTimelogs() {
  yield takeEvery(LOAD_TIMELOGS, loadEntities);
}

function* loadTaskTimelogs() {
  yield takeEvery(LOAD_TASK_TIMELOGS, loadEntities);
}

function* subscribeTimerStarted() {
  while (true) {
    yield take(SUBSCRIBE_TIMER_STARTED);
    const chanel = yield call(socketInstance.onSubscribe, SOCKET.timerStarted);
    const task = yield takeEvery(chanel, function*(data) {
      yield put(setTimerStartedSocket(data));
    });

    yield take([...LOGOUT_ACTION_TYPES, UNSUBSCRIBE_TIMER_STARTED]);

    chanel.close();
    yield cancel(task);

    yield call(socketInstance.onUnsubscribe, SOCKET.timerStarted);
  }
}

function* subscribeTimerStopped() {
  while (true) {
    yield take(SUBSCRIBE_TIMER_STOPPED);
    const chanel = yield call(socketInstance.onSubscribe, SOCKET.timerStopped);
    const task = yield takeEvery(chanel, function*(data) {
      yield put(setTimerStoppedSocket(data));
    });

    yield take([...LOGOUT_ACTION_TYPES, UNSUBSCRIBE_TIMER_STOPPED]);

    chanel.close();
    yield cancel(task);

    yield call(socketInstance.onUnsubscribe, SOCKET.timerStopped);
  }
}

export default function* rootSaga() {
  yield all([
    fork(startTimer),
    fork(stopTimer),
    fork(initTimer),
    fork(deleteTimer),
    fork(updateTime),
    fork(loadTimelogs),
    fork(loadTaskTimelogs),
    fork(deleteTimerGroup),
    fork(subscribeTimerStarted),
    fork(subscribeTimerStopped),
  ]);
}
